module.exports = __webpack_public_path__ + "assets/images/cases/2.jpg";